<template>
  <div class="tournament-page">
    <section class="page-hero">
      <div class="app-container">
        <div class="page-hero__inner">
          <span class="eyebrow anim-fade-up">
            <i class="bi bi-trophy-fill text-flame"></i>
            {{ $t('tournament.eyebrow') || 'AGENDA KEJUARAAN' }}
          </span>
          <h1 class="page-hero__title anim-fade-up anim-delay-1">
            Turnamen Resmi <span class="text-flame">Arena Sport Digital</span>
          </h1>
          <p class="page-hero__desc anim-fade-up anim-delay-2">
            Ikuti kompetisi bergengsi, raih medali kejuaraan, dan buktikan keahlian terbaik kontingen Anda dalam ajang pencak silat profesional.
          </p>
        </div>
      </div>
    </section>

    <section class="section tournament-list-section">
      <TournamentGallery />
    </section>
  </div>
</template>

<script>
import TournamentGallery from '@/components/main/TournamentGallery.vue';

export default {
  name: 'TournamentPage',
  components: {
    TournamentGallery,
  },
};
</script>

<style scoped>
.tournament-page {
  min-height: 100vh;
  padding-bottom: var(--space-16);
}

.page-hero {
  position: relative;
  padding-block: var(--space-12) var(--space-10);
  background: var(--hero-bg);
  text-align: center;
  border-bottom: 1px solid var(--border-subtle);
}

@media (min-width: 768px) {
  .page-hero {
    padding-block: var(--space-20) var(--space-16);
  }
}

.page-hero__inner {
  max-width: 720px;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-hero__title {
  font-size: clamp(1.85rem, 5vw, 3.25rem);
  font-weight: 800;
  line-height: 1.25;
  margin-block: var(--space-4) var(--space-5);
  letter-spacing: -0.02em;
}

.page-hero__desc {
  font-size: clamp(var(--text-base), 2vw, var(--text-lg));
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

.tournament-list-section {
  padding-top: var(--space-10);
}
</style>
  